import { Typography } from 'antd';
import { noop } from 'lodash';
import React, { useState } from 'react';
import AppSearchInput from './AppSearchInput';
import { useModalState } from '../hooks/useModalState';
import ScoringSearchModal from './ScoringSearch';

export type ScoringSelectedType = {
  scoid?: string;
  scoreference?: string;
  collabel?: string;
};

export type ScoringSelectProps = {
  onChange?: any;
  value?: ScoringSelectedType;
  phase?: string;
  onlyScoid?: boolean;
};

const ScoringSelect = ({
  onChange = noop,
  value,
  phase,
  onlyScoid,
}: ScoringSelectProps) => {
  const [Params, setParams] = useState<ScoringSelectedType>({
    scoid: value?.scoid,
    scoreference: value?.scoreference,
    collabel: value?.collabel,
  });

  const { visible, close, open } = useModalState(false);
  const handleSelect = (item: any) => {
    onlyScoid ? onChange(item.scoid) : onChange(item);

    setParams({
      scoreference: item?.scoreference,
      collabel: item.collabel,
      scoid: item?.scoid,
    });
    close();
  };

  return (
    <>
      <AppSearchInput
        onSearch={open}
        value={
          <Typography.Link>
            {!value?.scoid
              ? Params?.scoid
                ? `${Params.scoreference ?? ''}  -  ${Params.collabel ?? ''}`
                : 'Select Scoring'
              : value?.scoid
              ? `${value.scoreference ?? ''}  -  ${value.collabel ?? ''}`
              : 'Select Scoring'}
          </Typography.Link>
        }
      />
      <ScoringSearchModal
        setScoring={handleSelect}
        visible={visible}
        onCancel={close}
      />
    </>
  );
};

export default ScoringSelect;
